/**
 * Thin indirection over `window.location` so that unit tests can replace it.
 *
 * Since jsdom 22 (Jest 30) `window.location` and its members are non-configurable and can neither be
 * redefined nor spied on; production code therefore goes through this object, which tests mock with
 * `jest.spyOn(windowLocation, 'reload')` etc.
 */
export const windowLocation = {
  reload(): void {
    window.location.reload();
  },

  /** Navigates the current window, e.g. to the identity provider or to hand a `maps:`/`geo:` scheme to the OS. */
  assign(url: string): void {
    window.location.href = url;
  },

  href(): string {
    return window.location.href;
  },

  origin(): string {
    return window.location.origin;
  },

  pathname(): string {
    return window.location.pathname;
  },
};
